import { BiPixel, Oewa } from '@derstandard/tracking';
import { v4 as uuid } from '@lukeed/uuid';

import { getEdition } from './utils.ts';

type TrackingOption = {
	oewa?: boolean;
	urlOverwrite?: boolean;
};

const edition = getEdition();
const propertyId =
	edition === 'de'
		? import.meta.env.VITE_SOURCEPOINT_CMP_PROPERTY_ID_DE
		: import.meta.env.VITE_SOURCEPOINT_CMP_PROPERTY_ID_AT;

const biPixel = new BiPixel({
	environment: import.meta.env.MODE as 'development' | 'production',
	pixelUrl: import.meta.env.VITE_BI_PIXEL_URL,
	receiverUrl: import.meta.env.VITE_BI_RECEIVER_URL,
});

const oewa = new Oewa({
	edition: edition,
	initialize: true,
	oewaPath: 'header/glocke/tabs',
	propertyId: Number(propertyId),
});

/**
 * Tracks a user action by sending a page impression to the BI Pixel and ÖWA.
 * @param userAction
 */
export function trackUserAction(userAction: keyof typeof settings): void {
	const correlationId = uuid();
	const userActionOption = settings[userAction] as TrackingOption;
	const baseUrl =
		edition === 'de' ? import.meta.env.VITE_BASE_URL_EDITORIALWEB_DE : import.meta.env.VITE_BASE_URL_EDITORIALWEB;

	biPixel.sendPageImpression({
		action: userAction,
		correlationid: correlationId,
		urloverwrite: userActionOption.urlOverwrite ? `${baseUrl}/notifications` : undefined,
	});

	if (userActionOption.oewa) {
		oewa.sendPageImpression(correlationId);
	}
}

const settings = {
	comreact_entertaining: {},
	comreact_helpful: {},
	comreact_info: {},
	comreact_like: {},
	comreact_react: {},
	comreact_touching: {},
	header_shownotif: {
		oewa: true,
		urlOverwrite: true,
	},
	header_shownotif_new: {
		oewa: true,
		urlOverwrite: true,
	},
	header_showprofile: {
		oewa: true,
		urlOverwrite: false,
	},
	header_tabchange_notifications: {
		oewa: true,
		urlOverwrite: true,
	},
	header_tabchange_notifications_new: {
		oewa: true,
		urlOverwrite: true,
	},
	header_tabchange_profile: {
		oewa: true,
		urlOverwrite: false,
	},
} as const;

/**
 * Helper function that initialized the dataLayer (if required) and pushes to it.
 * @param payload object to push to the dataLayer
 */
export function pushToDataLayer(payload: Record<string, unknown>) {
	window.dataLayer = window.dataLayer ?? [];

	window.dataLayer.push(payload);
}
